import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompetitionComponent } from './competition.component';
import { QuestionComponent } from './question/question.component';
import { RouterModule } from '@angular/router';
import { COMPETITIONS_ROUTES } from './competition.routes';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  ShowtimeStreamingSubscribeComponent,
  FormSubscriptionComponent
} from '@usheru-hff/movie-detail/feature-subscribe';
import {
  MovieCreditsComponent,
  MovieMoreInformationComponent,
  MovieReasonsToWatchComponent,
  MovieReviewsComponent,
  MovieRatingComponent,
  MovieSynopsisComponent,
  MovieTitleComponent,
  SeeMoreComponent,
  MovieInfoCreditsComponent,
  MovieTellFriendsComponent
} from '@usheru-hff/movie-detail/ui-movie-elements';
import { SharedUtilsModule } from '@usheru-hff/shared/utils';
import { SharedUtilsImageModule } from '@usheru-hff/shared/utils-image';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(COMPETITIONS_ROUTES),

    FontAwesomeModule,
    ShowtimeStreamingSubscribeComponent,
    FormSubscriptionComponent,
    MovieCreditsComponent,
    MovieMoreInformationComponent,
    MovieReasonsToWatchComponent,
    MovieReviewsComponent,
    MovieRatingComponent,
    MovieSynopsisComponent,
    MovieTitleComponent,
    SeeMoreComponent,
    MovieInfoCreditsComponent,
    MovieTellFriendsComponent,
    SharedUtilsModule,
    SharedUtilsImageModule,
    MovieTellFriendsComponent
  ],
  declarations: [CompetitionComponent, QuestionComponent],
  exports: [CompetitionComponent]
})
export class MovieDetailFeatureCompetitionsModule {}
